import React from "react";
import { AppPage } from "ui/AppPage";

export const TermsOfServicePage = () => (
  <AppPage>
    <h2>Yapa Terms of Service</h2>

    <p>
      Posted：29.06.2020
      <br />
      Effective：29.06.2020
    </p>

    <p>
      Thanks for using Yapa! These terms of service ("Terms") cover your use and
      access to the services, client software and websites ("Services") provided
      by Artur Kozubek company, NIP: 6472498447, Poland. Our Privacy Policy
      explains how we collect and use your information. By using our Services,
      you're agreeing to be bound by these Terms, and to review our Privacy
      policy. If you're using our Services for an organization, you're agreeing
      to these Terms on behalf of that organization.
    </p>

    <h3>Your Stuff & Your Permissions</h3>
    <p>
      When you use our Services, you provide us with things like your content,
      email address and so on ("Your Stuff"). Your Stuff is yours. These Terms
      don't give us any rights to Your Stuff except for the limited rights that
      enable us to offer the Services. We need your permission to do things like
      hosting Your Stuff, backing it up, and sharing it when you ask us to. Our
      Services also provide you with features like editing, organizing, sharing
      and searching. These and other features may require our systems to access,
      store Your Stuff. You give us permission to do those things, and this
      permission extends to trusted third parties we work with.
    </p>

    <h3>Your Responsibilities</h3>
    <p>
      Please safeguard your password to the Services, make sure that others
      don't have access to it, and keep your account information current.
      <br />
      You agree not to misuse the Services. For example, you must not, and must
      not attempt to do the following:
    </p>

    <ul>
      <li>probe, scan, or test the vulnerability of any system or network;</li>
      <li>
        access, tamper with, or use non-public areas or parts of the Services,
        or shared areas of the Services you haven't been invited to;
      </li>
      <li>abuse Yapa referrals or promotions;</li>
      <li>sell the Services or Services accounts via unauthorized channels;</li>
      <li>
        use automated or other means to create accounts in bulk or to access the
        Services other than by using our official interface and/or APIs;
      </li>
    </ul>

    <h3>Mailing</h3>
    <p>
      By signing up to Yapa Services you give us permission to inform you about
      Artur Kozubek company activities via email.
    </p>

    <h3>Software</h3>
    <p>
      Some of our Services allow you to download client software ("Software")
      which may update automatically. So long as you comply with these Terms, we
      give you a limited, nonexclusive, nontransferable, revocable license to
      use the Software, solely to access the Services. To the extent any
      component of the Software may be offered under an open source license,
      we'll make that license available to you and the provisions of that
      license may expressly override some of these Terms. Unless the following
      restrictions are prohibited by law, you agree not to reverse engineer or
      decompile the Services, attempt to do so, or assist anyone in doing so.
    </p>

    <h3>Our Stuff</h3>
    <p>
      The Services are protected by copyright, trademark, and other Poland and
      foreign laws. These Terms don't grant you any right, title or interest in
      the Services, others' content in the Services, Yapa trademarks, logos and
      other brand features. We welcome feedback, but note that we may use
      comments or suggestions without any obligation to you.
    </p>

    <h3>Liability for our Services</h3>
    <p>
      When permitted by law, we will not be responsible for lost profits,
      revenues, or data, financial losses or indirect, special, consequential,
      exemplary, or punitive damages. The total liability of us is limited to
      the amount you paid us to use the Services.
    </p>

    <h3>Termination</h3>
    <p>
      You're free to stop using our Services at any time. We also reserve the
      right to suspend or end the Services at any time at our discretion and
      without notice. For example, we may suspend or terminate your use of the
      Services if you're not complying with these Terms, or use the Services in
      a manner that would cause us legal liability, disrupt the Services or
      disrupt others' use of the Services.
    </p>

    <h3>Modifications</h3>
    <p>
      We may revise these Terms from time to time, and will always post the most
      current version on our website. If a revision meaningfully reduces your
      rights, we will notify you (by, for example, sending a message to the
      email address associated with your account, posting on our blog or on this
      page). By continuing to use or access the Services after the revisions
      come into effect, you agree to be bound by the revised Terms.
    </p>

    <h3>Controlling Law</h3>
    <p>These Terms will be governed by the laws of Poland.</p>
  </AppPage>
);
